module.exports = __webpack_public_path__ + "static/media/levelup.408bbb47.jpg";